import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Container,
  Form,
  Row,
  Stack,
  ThemeProvider,
} from "react-bootstrap";
import "../css/popupModule.css"
import logo from "../Assets/Logo/NYC-Logo.png";
import { FaArrowLeft } from "react-icons/fa";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { LoadingScreen } from "../LoadingScreen";
import axios from 'axios'
import SuccessPopup from "./SuccessPopup";

const ExistingCustomerAuthentication = () => {
  const [otpScreen, setOtpScreen] = useState(false);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const inputStyle = { borderRadius: "0", padding: "0.6rem" };
  const buttonStyle = {
    borderRadius: "0",
    padding: "0.6rem",
    marginBottom: "8px",
  };

  const handleBackClick = () => {
    navigate("/"); // Navigate to the home screen
  };

  const handleEmailClick = () => {
    setOtpScreen(false)
    sessionStorage.removeItem("userExists")
  };

  const [isValidEmail, setIsValidEmail] = useState(true);

  const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;

  const handleChangeEmail = (value) => {
    setEmail(value);
  };

  const handleChangeOTP = (value) => {
    if (/^\d{0,4}$/.test(value)) {
      setOtp(value);
    }
  };

  const generateAndStoreToken = async (email) => {
    try {
      // Call the API to generate a 30-minute token
      const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/auth/verify/generate-120min-token`, { email });

      // Check if the response is successful and contains the token
      if (response.data.token) {
        // Store the token in localStorage
        localStorage.setItem('120MinToken', response.data.token);
        console.log('Token stored successfully:', response.data.token);
      } else {
        console.error('No token received:', response.data.message);
      }
    } catch (error) {
      console.error('Error generating token:', error.response ? error.response.data : error.message);
    }
  };

  const existEmailValidation = async (e) => {
    e.preventDefault();
    const apiUrl = `${process.env.REACT_APP_SERVER_URL}/api/validEmail/fetch-contact`;
    setLoading(true);
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const textData = await response.text();
      if (!textData) {
        throw new Error("Empty response from server");
      }

      let data;
      try {
        data = JSON.parse(textData);
      } catch (error) {
        throw new Error("Invalid JSON received from server");
      }

      console.log("existing user data", data);

      // Check if user exists and has valid contact and account IDs
      if (data.userExists && data.contactid && data.accountid) {
        const contactGUID = data.contactid;
        const accountGUID = data.accountid;
        const categoryData = data.categoryData || '';
        const categoryArray = categoryData.split(';').map(item => item.trim());

        sessionStorage.setItem("userExists", true);

        // Cache user data
        const cache = await caches.open('user-data-cache');
        const request = new Request('/user-data');
        const response = new Response(JSON.stringify({
          contactId: contactGUID,
          accountId: accountGUID,
        }), {
          headers: { 'Content-Type': 'application/json' }
        });
        await cache.put(request, response);
        localStorage.setItem('selectedCategories', JSON.stringify(categoryArray));
        // Proceed with email submission
        await handleEmailSubmit(e);
        //setLoading(false);
      } else {
        // Handle case when user does not exist
        sessionStorage.setItem("userExists", false);
        setLoading(false);
        await handleEmailSubmit(e);
      }
    } catch (error) {
      console.error("An error occurred:", error);
      toast.error("It seems there’s an issue with your internet connection")
      setLoading(false);
    }
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setIsValidEmail(emailRegex.test(email));
    try {
      setLoading(true);
      const tokenData = localStorage.getItem("auth-token");
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/api/auth/verify/send-otp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            // guid: opportunityGUID,
          }),
        }
      );
      const data = await response.json();
      
      if (response.ok) {
        toast.success(data.message);
        localStorage.setItem("EmailResponse", JSON.stringify(data));
        // localStorage.setItem("NewUserEmail", email);
        sessionStorage.setItem("NewUserEmail", email);
        setOtp("");
        setOtpScreen(true);
        setLoading(false);
      } else {
        toast.error(data.error);
        setLoading(false);
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
      setLoading(false);
    }
  };

  // const handleOtpSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     setLoading(true);
  //     // Retrieve the email response from local storage
  //     const emailResponse = JSON.parse(localStorage.getItem("EmailResponse"));

  //     if (!emailResponse || !emailResponse.token) {
  //       throw new Error("No token found in email response");
  //     }

  //     const payload = {
  //       token: emailResponse.token,
  //       otp: parseInt(otp),
  //     };

  //     const response = await fetch(
  //       `${process.env.REACT_APP_SERVER_URL}/api/auth/verify/verify-otp`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(payload),
  //       }
  //     );

  //     // Parse the response body
  //     const data = await response.json();

  //     if (response.ok && data.success) {
  //       // Response is OK and OTP is valid
  //       sessionStorage.setItem("OtpResponse", JSON.stringify(data));
  //       const userExists = JSON.parse(sessionStorage.getItem("userExists"));
  //       if (userExists) {
  //         localStorage.setItem("validWithOTP", true);
  //         localStorage.setItem("callApiData", true)
  //         localStorage.setItem("validSalesPerson", false);
  //         localStorage.setItem("validNewCustomer", false);
  //         localStorage.setItem("newCustomer", false);
  //         toast.success(
  //           "Log in successful. Please wait while we redirect you to the next screen"
  //         );
  //         setTimeout(() => {
  //           navigate("/home/recent-orders");
  //           window.location.reload();
  //           setLoading(false);
  //         }, 3000);
  //         sessionStorage.removeItem("userExists");
  //         await generateAndStoreToken(emailResponse.email)
  //       } else {
  //         localStorage.setItem("validWithOTP", true);
  //         localStorage.setItem("validSalesPerson", false);
  //         localStorage.setItem("validNewCustomer", true);
  //         localStorage.setItem('scannedQR', false);
  //         toast.success(
  //           "Sign up successful. Please wait while we redirect you to the next screen"
  //         );
  //         setTimeout(() => {
  //           navigate("/client-information");
  //           window.location.reload();
  //           setLoading(false);
  //         }, 3000);
  //         sessionStorage.removeItem("userExists");
  //         await generateAndStoreToken(emailResponse.email)
  //       }
  //     } else {
  //       // Handle error based on response content
  //       console.error("Error response:", data.message || 'Unknown error');
  //       toast.error(data.message || 'An error occurred');
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     console.error("An error occurred:", error);
  //     toast.error("An error occurred. Please try again.");
  //     setLoading(false);
  //   }
  // };

  // const handleOtpSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     setLoading(true);
  //     const emailResponse = JSON.parse(localStorage.getItem("EmailResponse"));
  
  //     if (!emailResponse || !emailResponse.token) {
  //       throw new Error("No token found in email response");
  //     }
  
  //     const payload = {
  //       token: emailResponse.token,
  //       otp: parseInt(otp),
  //     };
  
  //     const response = await fetch(
  //       `${process.env.REACT_APP_SERVER_URL}/api/auth/verify/verify-otp`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(payload),
  //       }
  //     );
  
  //     const data = await response.json();
  
  //     if (response.ok && data.success) {
  //       sessionStorage.setItem("OtpResponse", JSON.stringify(data));
  //       const userExists = JSON.parse(sessionStorage.getItem("userExists"));
  
  //       // Temporarily store the data to be saved later
  //       const userData = userExists
  //         ? {
  //             validWithOTP: true,
  //             callApiData: true,
  //             validSalesPerson: false,
  //             validNewCustomer: false,
  //             newCustomer: false,
  //             redirectPath: "/home/recent-orders",
  //           }
  //         : {
  //             validWithOTP: true,
  //             validSalesPerson: false,
  //             validNewCustomer: true,
  //             scannedQR: false,
  //             redirectPath: "/client-information",
  //           };
  //       setTemporaryUserData(userData); // Store in a temporary state
  //       setShowPopup(true); // Show confirmation popup
  
  //       await generateAndStoreToken(emailResponse.email);
  //       sessionStorage.removeItem("userExists");
  //     } else {
  //       console.error("Error response:", data.message || "Unknown error");
  //       toast.error(data.message || "An error occurred");
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     console.error("An error occurred:", error);
  //     toast.error("An error occurred. Please try again.");
  //     setLoading(false);
  //   }
  // };
  
  // // Confirmation handler for the popup
  // const handlePopupConfirm = () => {
  //   // Save data to localStorage upon confirmation
  //   Object.entries(temporaryUserData).forEach(([key, value]) => {
  //     localStorage.setItem(key, value);
  //   });
  
  //   // Close any open tabs with the same host URL
  //   closeTabsWithSameHost();
  
  //   // Redirect the user to the appropriate path
  //   navigate(temporaryUserData.redirectPath);
  //   window.location.reload();
  //   setShowPopup(false);
  // };
  
  // // Function to close other tabs with the same host
  // const closeTabsWithSameHost = () => {
  //   const allTabs = window.open('', '_self');
  //   if (allTabs) {
  //     allTabs.close();
  //   }
  // };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const emailResponse = JSON.parse(localStorage.getItem("EmailResponse"));

      if (!emailResponse || !emailResponse.token) {
        throw new Error("No token found in email response");
      }

      const payload = {
        token: emailResponse.token,
        otp: parseInt(otp),
      };

      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/api/auth/verify/verify-otp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (response.ok && data.success) {
        sessionStorage.setItem("OtpResponse", JSON.stringify(data));
        const userExists = JSON.parse(sessionStorage.getItem("userExists"));

        if (userExists) {
          await generateAndStoreToken(emailResponse.email);
          localStorage.setItem("validWithOTP", true);
          localStorage.setItem("callApiData", true);
          localStorage.setItem("validSalesPerson", false);
          localStorage.setItem("validNewCustomer", false);
          localStorage.setItem("newCustomer", false);
          localStorage.setItem("newUserValidation", false)
          toast.success(
            "Log in successful. Please wait while we redirect you to the next screen"
          );
          setTimeout(() => {
            navigate("/home/recent-orders");
            window.location.reload();
            setLoading(false);
          }, 3000);
          sessionStorage.removeItem("userExists");
        } else {
          // Show modal when user does not exist
          setLoading(false)
          setShowModal(true);
        }
      } else {
        console.error("Error response:", data.message || "Unknown error");
        toast.error(data.message || "An error occurred");
        setLoading(false);
      }
    } catch (error) {
      console.error("An error occurred:", error);
      toast.info("Please try again.");
      setLoading(false);
    }
  };

  const handleModalConfirm = async () => {
    setShowModal(false);
    await generateAndStoreToken(JSON.parse(localStorage.getItem("EmailResponse")).email);
    localStorage.setItem("validWithOTP", true);
    localStorage.setItem("validSalesPerson", false);
    localStorage.setItem("validNewCustomer", true);
    localStorage.setItem("scannedQR", false);
    localStorage.setItem("newUserValidation", true)
    toast.success(
      "Sign up successful. Please wait while we redirect you to the next screen"
    );
    setTimeout(() => {
      navigate("/client-information");
      window.location.reload();
      setLoading(false);
    }, 3000);
    sessionStorage.removeItem("userExists");
  };

  const handleModalCancel = () => {
    setShowModal(false);
    navigate("/")
    setLoading(false);
  };
  
  
  return (
    <ThemeProvider
      breakpoints={["xxxl", "xxl", "xl", "lg", "md", "sm", "xs", "xxs"]}
      minBreakpoint="xxs"
    >
      {!otpScreen ? (
        <div className="bg-white min-h-screen  flex justify-center items-center">
          {loading && <LoadingScreen />}
          <div className="flex justify-center bg-white h-fit px-4">
            <div className="bg-white max-w-sm">
              <Container className="p-4">
                <Row>
                  <Stack gap={4}>
                    <Card.Text
                      onClick={handleBackClick}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        padding: "5px",
                        // width: "20px",
                        // borderRadius: "50%",
                        // border: "1px solid red",
                        // transition: "background-color 0.3s",
                      }}
                    // onMouseEnter={(e) =>
                    //   (e.currentTarget.style.backgroundColor = "#e0e0e0")
                    // }
                    // onMouseLeave={(e) =>
                    //   (e.currentTarget.style.backgroundColor = "transparent")
                    // }
                    >
                      <FaArrowLeft style={{ marginRight: "8px" }} />
                    </Card.Text>
                    <Card
                      className="d-flex justify-content-center align-items-center gap-3"
                      style={{ border: "none" }}
                    >
                      <Card.Img
                        variant="top"
                        src={logo}
                        style={{ width: "10rem", objectFit: "contain" }}
                      />
                      <Card.Title className="text-2xl font-bold">
                        Log in
                      </Card.Title>
                      <Card.Text className="mx-4 text-center">
                        Welcome back! Please sign in to continue.
                      </Card.Text>
                    </Card>
                    <Form onSubmit={existEmailValidation}>
                      <Form.Group className="mb-3" controlId="formGroupEmail">
                        <Form.Label className="d-flex">
                          <div className="d-flex justify-between w-full">
                            <div className="d-flex">
                              <p>Email address</p>
                              <p className="text-[#dc0a0b] ml-0.5">*</p>
                            </div>
                            <p>
                              {!isValidEmail && (
                                <p className="text-red-600">
                                  Invalid email format
                                </p>
                              )}
                            </p>
                          </div>
                        </Form.Label>
                        <Form.Control
                          type="email"
                          value={email}
                          onChange={(e) => handleChangeEmail(e.target.value)}
                          placeholder="Enter Email"
                          style={inputStyle}
                        />
                      </Form.Group>
                      <Row className="mx-auto">
                        <Button
                          variant="secondary"
                          style={buttonStyle}
                          type="submit"
                          className="me-3 text-lg bg-[#dc0a0b] border-[#dc0a0b] hover:bg-[#c40909] hover:border-[#c40909]"
                        >
                          Get One Time Passcode
                        </Button>
                      </Row>
                    </Form>
                  </Stack>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      ) : (
        <div className="bg-white min-h-screen  flex justify-center items-center">
          {loading && <LoadingScreen />}
          <div className="flex justify-center bg-white h-fit px-4">
          {showModal && (
              <SuccessPopup loginApprove={handleModalConfirm} loginDisapprove={handleModalCancel} />
            )}
            <div className="bg-white max-w-sm">
              <Container className="p-4">
                <Row>
                  <Stack gap={2}>
                    <Card.Text
                      onClick={handleEmailClick}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        padding: "5px",
                        // width: "20px",
                        // borderRadius: "50%",
                        // border: "1px solid red",
                        // transition: "background-color 0.3s",
                      }}
                    // onMouseEnter={(e) =>
                    //   (e.currentTarget.style.backgroundColor = "#e0e0e0")
                    // }
                    // onMouseLeave={(e) =>
                    //   (e.currentTarget.style.backgroundColor = "transparent")
                    // }
                    >
                      <FaArrowLeft style={{ marginRight: "8px" }} />
                    </Card.Text>
                    <Card
                      className="d-flex justify-content-center align-items-center gap-3"
                      style={{ border: "none" }}
                    >
                      <Card.Img
                        variant="top"
                        src={logo}
                        style={{ width: "10rem", objectFit: "contain" }}
                      />
                      <Card.Title className="text-2xl font-bold">
                        Log in
                      </Card.Title>
                      <Card.Text className="mx-4 text-center">
                        Please provide the One Time Passcode sent to your email address
                      </Card.Text>
                    </Card>
                    <Form onSubmit={handleOtpSubmit}>
                      <Form.Group className="mb-3" controlId="formGroupEmail">
                        <Form.Label className="d-flex">
                          <p>One Time Passcode</p>
                          <p className="text-[#dc0a0b] ml-0.5">*</p>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          value={otp}
                          name="OTP"
                          onChange={(e) => handleChangeOTP(e.target.value)}
                          placeholder="Enter One Time Passcode"
                          style={inputStyle}
                          maxLength="4"
                          pattern="\d{4}"
                        />
                      </Form.Group>
                      <Row className="mx-auto">
                        <Button
                          variant="secondary"
                          style={buttonStyle}
                          type="submit"
                          className="me-3 text-lg bg-[#dc0a0b] border-[#dc0a0b] hover:bg-[#c40909] hover:border-[#c40909]"
                        >
                          Verify One Time Passcode
                        </Button>
                      </Row>
                    </Form>
                  </Stack>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      )}
    </ThemeProvider>
  );
};

export default ExistingCustomerAuthentication;
